import gql from 'graphql-tag';

const CUSTOMER_FEEDBACK_SETTING = gql`
  query CustomerFeedbackSetting($teacher_id: ID!) {
    customer_feedback_setting(teacher_id: $teacher_id) {
      is_disabled,
      is_due_for_display
    }
  }
`;

const CUSTOMER_FEEDBACK_SETTING_MSB = gql`
  query CustomerFeedbackSetting($teacher_id: ID!) {
    customer_feedback_setting: customerFeedbackSetting(teacher_id: $teacher_id) {
      is_disabled,
      is_due_for_display
    }
  }
`;

const CUSTOMER_FEEDBACK_QUESTIONS = gql`
  query CustomerFeedbackForm($platform: Int!) {
    customer_feedback_questions(platform: $platform) {
      id,
      option_group,
      question_ja,
      question_en,
      is_detail_required
    },
    customer_feedback_options {
      option_group,
      vote_value,
      option_ja,
      option_en
    }
  }
`;

const CUSTOMER_FEEDBACK_QUESTIONS_MSB = gql`
  query CustomerFeedbackForm($platform: Int!) {
    customer_feedback_questions: customerFeedbackQuestions(platform: $platform) {
      id,
      option_group,
      question_ja,
      question_en,
      is_detail_required
    },
    customer_feedback_options: customerFeedbackOptions {
      option_group,
      vote_value,
      option_ja,
      option_en
    }
  }
`;

export { 
  CUSTOMER_FEEDBACK_SETTING, 
  CUSTOMER_FEEDBACK_SETTING_MSB,
  CUSTOMER_FEEDBACK_QUESTIONS, 
  CUSTOMER_FEEDBACK_QUESTIONS_MSB
};
